// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2C2Dj","list":"PatternAutocomplete_list__1NK4N"};